import * as React from 'react';
import styled from 'styled-components';
import {
	whiteColour,
	superLightGreyColour,
	brandingColourHeavy,
	tabletPortraitMinWidth,
	tabletLandscapeMinWidth,
	labelRedColour
} from '../../cssConstants';
import FormButtons from './FormButton';

// Note: This is for the sub page body section, which doesn't have the main Layout, back button and Helmet, and footer etc.
const SubPageLayout = ({
	icon,
	iconAlt,
	title,
	paragraphs,
	onPrimaryButtonClick = null,
	primaryButtonText = null,
	onSecondaryButtonClick = null,
	secondaryButtonText = null,
	smallMarginTop = false,
	imageWidth,
	imageHeight,
	mailTo,
	isWarning = false
}: Props) => {
	return (
		<Container>
			<Img
				src={icon}
				alt={iconAlt}
				$smallMarginTop={smallMarginTop}
				$imageWidth={imageWidth}
				$imageHeight={imageHeight}
			/>
			<TextSection>
				<PageTitle $isWarning={isWarning}>{title}</PageTitle>
				{paragraphs.map((paragraph) => (
					<PageParagraph key={paragraph}>{paragraph}</PageParagraph>
				))}
			</TextSection>
			<FormButtons
				continueButtonText={primaryButtonText}
				onOtherButtonClick={onSecondaryButtonClick}
				otherButtonText={secondaryButtonText}
				onContinueButtonClick={onPrimaryButtonClick}
				mailTo={mailTo}
				isWarning={isWarning}
			/>
		</Container>
	);
};

export default SubPageLayout;

interface Props {
	icon: '*.svg';
	iconAlt: string;
	title: string;
	paragraphs: string[];
	onPrimaryButtonClick?: () => void;
	primaryButtonText?: string;
	onSecondaryButtonClick?: () => void;
	secondaryButtonText?: string;
	smallMarginTop?: boolean;
	imageWidth?: string;
	imageHeight?: string;
	mailTo?: string;
	isWarning?: boolean;
}

const Container = styled.div`
	text-align: center;
	color: ${whiteColour};
`;

const TextSection = styled.div`
	text-align: left;
	margin: 0 auto;

	&:first-child {
		margin-top: 0;
	}
`;

export const PageTitle = styled.h1<{ $isWarning: boolean }>`
	margin: 0 auto 10px auto;
	font-size: 24px;
	font-style: normal;
	font-weight: 400;
	line-height: 32px;
	color: ${(props) => (props.$isWarning ? labelRedColour : brandingColourHeavy)};
	text-align: center;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 28px;
		line-height: 36px;
	}
`;

const PageParagraph = styled.p`
	margin: 0 auto 16px auto;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: ${superLightGreyColour};
	text-align: center;

	&:last-child {
		margin-bottom: 0;
	}

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
		line-height: 22px;
	}
`;

const Img = styled.img<{ $smallMarginTop: boolean; $imageWidth: string; $imageHeight: string }>`
	width: ${(props) => (props.$imageWidth ? props.$imageWidth : '96px')};
	height: ${(props) => (props.$imageHeight ? props.$imageHeight : '96px')};
	margin: 99px auto 25px auto;
	margin-top: ${(props) => (props.$smallMarginTop ? '19px' : '99px')};

	@media (min-width: ${tabletLandscapeMinWidth}) {
		margin-top: 19px;
	}
`;
